import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type { PriceChangeFilterOptions, PriceChangeType, Query } from "@/graphql/codegen/graphql"
import { GetPriceChangeFilterOptionsDocument } from "@/graphql/codegen/graphql"

interface UseGetPriceChangeFilterOptionsReturn {
  filterOptions: PriceChangeFilterOptions | null
  fetching: boolean
}

export const useGetPriceChangeFilterOptions = ({
  changeType,
  supplierId,
  customerIds,
  productCategoryId,
  productManagerId,
  productClassId,
  specificProductIds,
  shipFromId,
  shipToId,
  pause,
}: {
  changeType?: PriceChangeType
  supplierId?: string
  customerIds?: string[]
  productCategoryId?: string
  productManagerId?: string
  productClassId?: string
  shipFromId?: string
  shipToId?: string
  specificProductIds?: number[]
  pause?: boolean
}): UseGetPriceChangeFilterOptionsReturn => {
  const [filterOptions, setFilterOptions] = useState<PriceChangeFilterOptions | null>(null)

  const [{ data, fetching }] = useQuery<Pick<Query, "priceChange">>({
    query: GetPriceChangeFilterOptionsDocument,
    variables: {
      input: {
        ...(changeType && changeType?.length && { changeType }),
        ...(supplierId && supplierId?.length && { supplierId }),
        ...(customerIds && customerIds?.length && { customerIds }),
        ...(productCategoryId && productCategoryId?.length && { productCategoryId }),
        ...(productManagerId && productManagerId?.length && { productManagerId }),
        ...(productClassId && productClassId?.length && { productClassId }),
        ...(specificProductIds && specificProductIds?.length && { specificProductIds }),
        ...(shipFromId?.length && { shipFromId }),
        ...(shipToId?.length && { shipToId }),
      },
    },
    pause: pause || !changeType,
  })

  useEffect(() => {
    if (data?.priceChange?.getPriceChangeFilterOptions?.__typename === "GetPriceChangeFilterOptionsSuccess") {
      setFilterOptions(data.priceChange.getPriceChangeFilterOptions.filterOptions)
    }
  }, [data])

  return {
    filterOptions,
    fetching,
  }
}
